import React from 'react';
import './OurIndustries.scss';
import IndustriesList from "./IndustriesList/IndustriesList";
import InfinityCarouselStaticWidth from "../../helpers/InfinityCarouselStaticWidth/InfinityCarouselStaticWidth";

function OurIndustries() {

    return (
        <div className="OurIndustries modal-bg">
            <div className="content">
                <div className={'groupTitle'}>
                    <div className={'titleKey'}>Engineering Contexts</div>
                    <div className={'title'}>Where We Engage</div>
                </div>
                <div className={'text'}>Recurring engineering situations where we design and build systems.</div>
                <div className={'cards'}>
                    <div className={'cards__item'}>
                        <div className={'title'}>Zero-to-one Product Engineering</div>
                        <div className={'text'}>From undefined problem space to production-ready system architecture.</div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'title'}>Engineering Leadership Support</div>
                        <div className={'text'}>Redesigning systems that no longer support real operations.</div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'title'}>AI System Integration</div>
                        <div className={'text'}>Embedding AI into existing systems with clear architectural control.</div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'title'}>System Rescue and Scaling</div>
                        <div className={'text'}>Building systems that remain stable under real-world load.</div>
                    </div>
                </div>
            </div>
            {/*{window.innerWidth > 1440*/}
            {/*    ? <IndustriesList/> */}
            {/*    : <InfinityCarouselStaticWidth itemRender={IndustriesList} itemWidth={window.innerWidth > 768 ? 2215 : (window.innerWidth > 450 ? 2150 : 1740)} />*/}
            {/*}*/}
            <div id={'completed-projects'} style={{
                position: 'relative',
                bottom: '100px'
            }}/>
        </div>
    );
}

export default OurIndustries;
